import { OrganisationListItem, WorkspacesListingItem } from '@futrli-sdk/workspaces';

/**
 * Iterates through workspaces listing page endpoint response and returns organisation that
 * contains sage50 org (org.sxp_business_id === businessId)
 * @param workspaces list of all workspaces
 * @param businessId sage50 business id
 * @returns Sage50 organisation if it exitsts
 */
export const getSage50Org = (workspaces: WorkspacesListingItem[], businessId: string): OrganisationListItem | null => {
  for (const w of workspaces) {
    const sage50Org = w.organisations.find(o => o.sxp_business_id === businessId);

    if (sage50Org) {
      return sage50Org;
    }
  }
  return null;
};

/**
 * Iterates through workspaces listing page endpoint response and returns workspace that contains sage50 org
 * @param workspaces list of all workspaces
 * @param organisationId organisationId of sage50 org
 * @returns workspace that contains organisation with given orgId
 */
export const getSage50Workspace = (
  workspaces: WorkspacesListingItem[],
  organisationId: string
): WorkspacesListingItem | null => {
  for (const w of workspaces) {
    const workspaceContainsOrg = w.organisations.find(o => o.id === organisationId);
    if (workspaceContainsOrg) {
      return w;
    }
  }
  return null;
};
